import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getSelectedShop } from '../../reducers/selectors';
import Navigation from './Navigation';
import SideMenu from '../SideMenu';
import CollapseButton from './CollapseButton';
import { getPartFromPath } from '../../utils/urlPathHelper';

import './PageContainer.scss';

export class PageContainer extends React.PureComponent {
  state = {
    menuCollapsed: this.props.menuCollapsed,
  };

  toggleMenu = () => {
    this.setState((state) => ({ menuCollapsed: !state.menuCollapsed }));
  };

  render() {
    const { menuItems, location, onSelectMenu, collapsible, menuTitle } = this.props;

    const { menuCollapsed } = this.state;

    const selectedProduct = getPartFromPath(location.pathname, 0);

    return (
      <div styleName="page">
        <Navigation location={location} selectedProduct={selectedProduct} />
        <div styleName="menu-with-content">
          {menuItems && (
            <React.Fragment>
              {!menuCollapsed && (
                <SideMenu title={menuTitle} items={menuItems} pathname={location.pathname} onSelect={onSelectMenu} />
              )}
              {collapsible && <CollapseButton collapsed={menuCollapsed} onClick={this.toggleMenu} />}
            </React.Fragment>
          )}
          <div styleName="content">
            <div styleName="content-wrapper">{this.props.children}</div>
          </div>
        </div>
      </div>
    );
  }
}

PageContainer.defaultProps = {
  menuCollapsed: false,
  collapsible: false,
};

PageContainer.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.object), // undefined if you do not want side menu
  selectedMenuItem: PropTypes.string,
  onSelectMenu: PropTypes.func,
  menuCollapsed: PropTypes.bool,
  collapsible: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    selectedShop: getSelectedShop(state),
  };
}

export default connect(mapStateToProps, null)(PageContainer);
